'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _htmlparser = require('htmlparser2');

var _htmlparser2 = _interopRequireDefault(_htmlparser);

var _Colours = require('@/helpers/Colours');

var Colours = _interopRequireWildcard(_Colours);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Vue = require('vue');

exports.default = Vue.component('irc-input', {
    props: ['placeholder'],
    data: function data() {
        return {
            last_known_value: '',
            text_value: '',
            current_el: null,
            current_el_pos: 0,
            default_colour: null,
            code_map: (0, _create2.default)(null)
        };
    },

    computed: {
        editor: function editor() {
            return this.$refs.editor;
        }
    },
    mounted: function mounted() {
        this.resetStyles();
    },

    methods: {
        onTextInput: function onTextInput(event) {
            if (event.data[event.data.length - 1] === '\n') {
                event.preventDefault();
                this.setCurrentWord(event.data.trim());
            }
        },
        onPaste: function onPaste(event) {
            var _this = this;

            event.preventDefault();
            if (typeof event.clipboardData !== 'undefined') {
                var ignoreThisPaste = false;
                var clpData = event.clipboardData;
                clpData.types.forEach(function (type) {
                    var ignoreTypes = ['Files', 'image'];
                    ignoreTypes.forEach(function (ig) {
                        if (type.indexOf(ig) > -1) {
                            ignoreThisPaste = true;
                        }
                    });
                });

                if (ignoreThisPaste) {
                    return;
                }

                document.execCommand('insertText', false, clpData.getData('text/plain'));
            } else {
                var clpText = window.clipboardData.getData('Text');
                if (!clpText) {
                    return;
                }

                var selection = window.getSelection();
                var range = selection.getRangeAt(0);
                if (range) {
                    range.deleteContents();
                    range.insertNode(document.createTextNode(clpText));
                }
            }

            setTimeout(function () {
                _this.updateValueProps();
            }, 0);
        },
        onFocus: function onFocus(event) {
            if (!this.getRawText() && this.default_colour) {
                this.setColour(this.default_colour.code, this.default_colour.colour);
            }

            this.$emit('focus', event);
        },
        updateValueProps: function updateValueProps() {
            var selection = window.getSelection();

            if (selection.rangeCount === 0) {
                return;
            }

            this.current_el_pos = selection.anchorOffset;
            this.current_el = selection.anchorNode;

            this.maybeEmitInput();
        },
        selectionToEnd: function selectionToEnd() {
            var el = this.$refs.editor.lastChild || this.$refs.editor;
            this.current_el = el;

            if (el.nodeType === 3) {
                this.current_el_pos = el.length;
            } else {
                this.current_el_pos = 0;
            }

            this.focus();
        },
        setValue: function setValue(newVal) {
            this.value = newVal;
            this.$refs.editor.innerHTML = newVal;
        },
        getValue: function getValue() {
            return this.$refs.editor.innerHTML;
        },
        maybeEmitInput: function maybeEmitInput() {
            var currentHtml = this.$refs.editor.innerHTML;
            if (this.last_known_value !== currentHtml) {
                this.$emit('input', currentHtml);
                this.last_known_value = currentHtml;
            }
        },
        buildIrcText: function buildIrcText() {
            var _this2 = this;

            var source = this.$refs.editor.innerHTML;
            var textValue = '';

            var toggles = [];
            function addToggle(t) {
                toggles[toggles.length - 1] += t;
            }
            function getToggles() {
                return toggles[toggles.length - 1];
            }

            var parser = new _htmlparser2.default.Parser({
                onopentag: function onopentag(name, attribs) {
                    toggles.push('');
                    var codeLookup = '';
                    if (attribs.style) {
                        var match = attribs.style.match(/color: ([^;]+)/);
                        if (match) {
                            codeLookup = match[1];
                            var mappedCode = _this2.code_map[codeLookup];
                            if (!mappedCode) {
                                var m = codeLookup.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
                                if (m) {
                                    var hex = Colours.rgb2hex({
                                        r: parseInt(m[1], 10),
                                        g: parseInt(m[2], 10),
                                        b: parseInt(m[3], 10)
                                    });
                                    mappedCode = _this2.code_map[hex];
                                }
                            }

                            if (mappedCode) {
                                textValue += '\x03' + mappedCode;
                                addToggle('\x03' + mappedCode);
                            }
                        }

                        if (attribs.style.indexOf('bold') > -1) {
                            textValue += '\x02';
                            addToggle('\x02');
                        }
                        if (attribs.style.indexOf('italic') > -1) {
                            textValue += '\x1d';
                            addToggle('\x1d');
                        }
                        if (attribs.style.indexOf('underline') > -1) {
                            textValue += '\x1f';
                            addToggle('\x1f');
                        }
                    } else if (attribs.color) {
                        var _mappedCode = _this2.code_map[attribs.color] || _this2.code_map[attribs.color.replace(/,/g, ', ')] || _this2.code_map[Colours.hex2rgb(attribs.color)];

                        if (_mappedCode) {
                            textValue += '\x03' + _mappedCode;
                            addToggle('\x03' + _mappedCode);
                        }
                    } else if (name === 'strong') {
                        textValue += '\x02';
                        addToggle('\x02');
                    } else if (name === 'em') {
                        textValue += '\x1d';
                        addToggle('\x1d');
                    } else if (name === 'u') {
                        textValue += '\x1f';
                        addToggle('\x1f');
                    }

                    if (attribs.src && _this2.code_map[attribs.src]) {
                        textValue += _this2.code_map[attribs.src];
                    }
                },
                ontext: function ontext(text) {
                    textValue += text;
                },
                onclosetag: function onclosetag(tagName) {
                    textValue += getToggles();
                    toggles.pop();
                }
            }, {
                decodeEntities: true
            });

            parser.write(source);
            parser.end();

            return textValue;
        },
        reset: function reset(rawHtml) {
            this.$refs.editor.innerHTML = rawHtml || '';

            this.current_el_pos = 0;
            this.current_el = this.$refs.editor;

            var br = this.$refs.editor.querySelector('br');
            if (br) {
                br.parentNode.removeChild(br);
            }

            if (this.default_colour) {
                this.focus();
                this.setColour(this.default_colour.code, this.default_colour.colour);
            }

            this.updateValueProps();
        },
        resetStyles: function resetStyles() {
            this.focus();
            document.execCommand('styleWithCSS', false, true);
            document.execCommand('selectAll', false, null);
            document.execCommand('removeFormat', false, null);
            this.default_colour = null;
        },
        setColour: function setColour(code, colour) {
            var range = window.getSelection().getRangeAt(0);
            if (range && range.collapsed) {
                this.default_colour = {
                    code: code,
                    colour: colour
                };
            }

            this.focus();
            document.execCommand('styleWithCSS', false, true);
            document.execCommand('foreColor', false, colour);

            this.code_map[colour] = code;
            this.updateValueProps();
        },
        toggleBold: function toggleBold() {
            document.execCommand('bold', false, null);
            this.updateValueProps();
        },
        toggleItalic: function toggleItalic() {
            document.execCommand('italic', false, null);
            this.updateValueProps();
        },
        toggleUnderline: function toggleUnderline() {
            document.execCommand('underline', false, null);
            this.updateValueProps();
        },
        addImg: function addImg(code, url) {
            this.focus();

            var existingImages = [].concat((0, _toConsumableArray3.default)(_lodash2.default.values(this.$refs.editor.querySelectorAll('img'))));

            document.execCommand('styleWithCSS', false, true);
            document.execCommand('insertImage', false, url);
            this.code_map[url] = code;

            var newImg = null;
            var images = [].concat((0, _toConsumableArray3.default)(_lodash2.default.values(this.$refs.editor.querySelectorAll('img'))));

            images.forEach(function (img) {
                if (existingImages.indexOf(img) === -1) {
                    newImg = img;
                }
            });

            var prevElCnt = 0;
            var el = newImg;
            while (el) {
                el = el.previousSibling;
                prevElCnt++;
            }

            this.current_el = this.$refs.editor;
            this.current_el_pos = prevElCnt;

            this.updateValueProps();
            this.focus();
        },
        insertText: function insertText(text) {
            this.focus();
            document.execCommand('insertText', false, text);
            this.updateValueProps();
            this.focus();
        },
        setCurrentWord: function setCurrentWord(text, keepPosition) {
            var el = this.current_el;
            var pos = this.current_el_pos;
            var val = el.textContent || '';

            var startVal = val.substr(0, pos);
            var space = startVal.lastIndexOf(' ');
            if (space === -1) {
                space = 0;
            } else {
                space++;
            }
            var startPos = space;

            var endVal = val.substr(pos);
            space = endVal.indexOf(' ');
            if (space === -1) space = endVal.length;
            var endPos = space;

            el.textContent = startVal.substr(0, startPos) + text + endVal.substr(endPos);

            var range = document.createRange();
            if (keepPosition) {
                range.setStart(el, pos);
                range.setEnd(el, pos);
            } else if (el.nodeType === 3) {
                range.setStart(el, startPos + text.length);
                range.setEnd(el, startPos + text.length);
            } else {
                range.setStart(el, 1);
                range.setEnd(el, 1);
            }

            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
            this.updateValueProps();
        },
        getCurrentWord: function getCurrentWord() {
            var el = this.current_el;
            var pos = this.current_el_pos;
            var val = el.textContent;

            var startVal = val.substr(0, pos);
            var space = startVal.lastIndexOf(' ');
            if (space === -1) {
                space = 0;
            } else {
                space++;
            }
            var startPos = space;

            space = val.indexOf(' ', startPos);
            if (space === -1) space = val.length;
            var endPos = space;

            return {
                word: val.substr(startPos, endPos),
                position: pos - startPos
            };
        },
        getRawText: function getRawText() {
            return this.$refs.editor.innerText;
        },
        focus: function focus() {
            var selection = window.getSelection();
            var range = document.createRange();
            range.setStart(this.current_el || this.$refs.editor, this.current_el_pos || 0);

            selection.removeAllRanges();
            selection.addRange(range);
        }
    }
});
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["utils"]) window._kiwi_exports["components"]["utils"] = {};
window._kiwi_exports["components"]["utils"]["IrcInput"]
window._kiwi_exports.components.utils.IrcInput = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/utils/IrcInput.vue
// module id = fGO0
// module chunks = 1